import { render } from "./BOPending.vue?vue&type=template&id=cdd83f18&scoped=true&ts=true"
import script from "./BOPending.vue?vue&type=script&lang=ts"
export * from "./BOPending.vue?vue&type=script&lang=ts"

import "./BOPending.vue?vue&type=style&index=0&id=cdd83f18&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cdd83f18"]])

export default __exports__